/**
 * Returns an inline SVG as an image source, or resolves a configured icon file
 * from the agreement-icons asset folder.
 */
export const getAgreementIconSource = (iconFileName: string, getAssetSource: (assetPath: string) => string): string => {
    if (/^\s*<svg(?:\s|>)/i.test(iconFileName)) {
        return `data:image/svg+xml,${encodeURIComponent(iconFileName)}`;
    }

    return getAssetSource(`agreement-icons/${iconFileName}`);
};
